/* eslint-disable sort-keys-fix/sort-keys-fix */
export const pillColors = {
    '#C8DAFF': {
        label: '#414B58',
        close: '#9DACCA',
    },
    '#BAF3E6': {
        label: '#FFFFFF',
        close: '#FFFFFF',
    },
    '#FFE7AD': {
        label: '#676A69',
        close: '#C2B592',
    },
    '#FFD7E1': {
        label: '#676773',
        close: '#C2AAB5',
    },
    '#EADEFE': {
        label: '#636879',
        close: '#B4AFC9',
    },
    '#91C0FF': {
        label: '#5C6879',
        close: '#6B88AF',
    },
    '#67D8BB': {
        label: '#414B58',
        close: '#55948B',
    },
    '#FFD063': {
        label: '#FFFFFF',
        close: '#FFFFFF',
    },
    '#FF93AE': {
        label: '#414B58',
        close: '#A47085',
    },
    '#C6A7FF': {
        label: '#414B58',
        close: '#867BAF',
    },
    '#2774F8': {
        label: '#F6F9FF',
        close: '#B1CDFC',
    },
    '#1DD4CC': {
        label: '#F6FDFD',
        close: '#AEEFED',
    },
    '#FCAB05': {
        label: '#FFFCF5',
        close: '#FEE1A5',
    },
    '#F72555': {
        label: '#FFF6F8',
        close: '#FCB0C2',
    },
    '#7F3EFF': {
        label: '#FAF7FF',
        close: '#D1B9FF',
    },
    '#2247A4': {
        label: '#E4E9F4',
        close: '#9EAED7',
    },
    '#0A9690': {
        label: '#E2F2F2',
        close: '#93D1CE',
    },
    '#AF6908': {
        label: '#F5EDE1',
        close: '#DCBD92',
    },
    '#B21B3D': {
        label: '#F6E4E8',
        close: '#DD9BAA',
    },
    '#601BA7': {
        label: '#ECE4F4',
        close: '#B99BD8',
    },
    '#0D6BAE': {
        label: '#E2EDF5',
        close: '#94BEDB',
    },
    '#2D7F17': {
        label: '#E6F0E3',
        close: '#A3C799',
    },
    '#D24322': {
        label: '#FAE8E4',
        close: '#EBAC9E',
    },
    '#A91580': {
        label: '#F5E3F0',
        close: '#D998C7',
    },
    '#414B58': {
        label: '#FFFFFF',
        close: '#FFFFFF',
    },
    '#16B7FF': {
        label: '#F6FCFF',
        close: '#ABE5FF',
    },
    '#1EC22D': {
        label: '#F6FDF7',
        close: '#AEE9B3',
    },
    '#FF6327': {
        label: '#FFF9F6',
        close: '#FFC7B1',
    },
    '#FF0BBA': {
        label: '#FFF5FC',
        close: '#FFA7E6',
    },
    '#63707E': {
        label: '#F9F9FA',
        close: '#C7CBD1',
    },
    '#6CCBF1': {
        label: '#414B58',
        close: '#578EA8',
    },
    '#88DB7D': {
        label: '#414B58',
        close: '#66966B',
    },
    '#FF9F76': {
        label: '#414B58',
        close: '#A47768',
    },
    '#F892DE': {
        label: '#414B58',
        close: '#A0709E',
    },
    '#8694A5': {
        label: '#FFFFFF',
        close: '#FFFFFF',
    },
    '#CAEEFD': {
        label: '#5D6D6C',
        close: '#9EAED7',
    },
    '#CBF6BC': {
        label: '#5D6D6C',
        close: '#9FBF9C',
    },
    '#FEDECF': {
        label: '#676870',
        close: '#C2AFA9',
    },
    '#FFD5F5': {
        label: '#676777',
        close: '#C2A9C3',
    },
    '#B6BFC9': {
        label: '#414B58',
        close: '#7E8793',
    },
};
//# sourceMappingURL=data:application/json;base64,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